import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { SELLERS_BASE_URL } from '../../api/Custom'
import { getToken } from '../../custome/action'

export const mapUnmapProductDataApi = createApi({
    reducerPath: 'mapUnmapProductDataApi',
    baseQuery: fetchBaseQuery({ baseUrl: SELLERS_BASE_URL }),
    tagTypes : ['mapUnmapProductData'],
    endpoints: (builder) => ({
        getChannelProductData: builder.mutation({
            query: (status) => ({
                url: `/getChannelProducts?pageNumber=${status?.pageNumber - 1}&type=${status?.type}&searchBy=${status?.searchBy}&searchValue=${status?.searchValue}`,
                method: 'GET',
                headers:  {
                    'Authorization': 'Bearer ' + getToken(),
                    'Content-Type': 'application/json'
                }
            }),
            providesTags : ['mapUnmapProductData']
        }),
        getStockSkuList: builder.query({
            query: () => ({
                url: `/getStockSkuList`,
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + getToken(),
                    'Content-Type': 'application/json'
                }
            })
        }),
        linkChannelProduct: builder.mutation({
            query: (data) => ({
                url: `/linkChannelProduct`,
                method: 'POST',
                body: data,
                headers: {
                    'Authorization': 'Bearer ' + getToken(),
                    'Content-Type': 'application/json'
                }
            }),
            invalidatesTags: ['mapUnmapProductData']
        }),
        deleteChannelProducts: builder.mutation({
            query: (ids) => ({
                url: `/deleteChannelProducts`,
                method: 'POST',
                body: ids,
                headers: {
                    'Authorization': 'Bearer ' + getToken(),
                    'Content-Type': 'application/json'
                }
            }),
            invalidatesTags: ['mapUnmapProductData']
        }),
        updateMappedChannelProduct: builder.mutation({
            query: (data) => ({
                url: `/updateMappedChannelProduct`,
                method: 'POST',
                body: data,
                headers: {
                    'Authorization': 'Bearer ' + getToken(),
                    'Content-Type': 'application/json'
                }
            }),
            invalidatesTags: ['mapUnmapProductData']
        }),
        restoreChannelProducts: builder.mutation({
            query: (ids) => ({
                url: `/restoreChannelProducts`,
                method: 'POST',
                body: ids,
                headers: {
                    'Authorization': 'Bearer ' + getToken(),
                    'Content-Type': 'application/json'
                }
            }),
            invalidatesTags: ['mapUnmapProductData']
        }),
    })
})

export const {
    useGetChannelProductDataMutation,
    useGetStockSkuListQuery,
    useLinkChannelProductMutation,
    useDeleteChannelProductsMutation,
    useUpdateMappedChannelProductMutation,
    useRestoreChannelProductsMutation,
} = mapUnmapProductDataApi